// Libraries
var React = require('react');
var uuid = require('uuid/v1');

// Styles
require('./FixtureGroup.scss');

// Components
var FixtureItemModule = require('./FixtureItemModule');
var FixturePromotion = require('./FixturePromotion');

const FixtureGroup = ({month}) => {
	const items = month.items.map((item, index) => {
		return(item.fixture !== null
			? <FixtureItemModule data={item} key={uuid()} />
			: <FixturePromotion promotion={item.promotion} key={uuid()} />
		);
	});

	return (
		<div className="FixtureGroup">
			{items.length > 0 &&
				<h3>{month.month}</h3>
			}
			{items}
		</div>
	)
};

module.exports = FixtureGroup;



// WEBPACK FOOTER //
// ./src/components/Fixtures/FixtureGroup.js